"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _constants = require("../../button/constants");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _utils = require("../../utils");

var _constants2 = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TdWithoutDocs = (0, _context.styledWithTheme)('td', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _utils.filterProps)(['width'])(prop) && (0, _isPropValid.default)(prop);
  }
})(function (_ref) {
  var selectors = _ref.theme.selectors,
      hasReducedSpacing = _ref.hasReducedSpacing,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _constants2.tdDefaultProps.textAlign : _ref$textAlign,
      _ref$verticalAlign = _ref.verticalAlign,
      verticalAlign = _ref$verticalAlign === void 0 ? _constants2.tdDefaultProps.verticalAlign : _ref$verticalAlign,
      width = _ref.width;
  var padding = (0, _utils.px)(selectors.space(_constants2.CELL_SPACING_HORIZONTAL));
  var styles = {
    verticalAlign: verticalAlign,
    textAlign: textAlign,
    width: width,
    paddingLeft: padding,
    paddingRight: padding
  };

  if (hasReducedSpacing) {
    var verticalPadding = "".concat(_constants.BORDER_WIDTH / 2 + _constants.OUTLINE_WIDTH, "px!important");
    styles.paddingTop = verticalPadding;
    styles.paddingBottom = verticalPadding;
  }

  return styles;
});
var Td = (0, _stencilReactDesc.describe)(TdWithoutDocs).description("Stencil-styled HTML 'td' element.");
Td.propTypes = _objectSpread(_objectSpread({}, _propTypes.widthPropTypes), {}, {
  textAlign: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-align' property for the element."),
  verticalAlign: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'vertical-align' property for the element."),
  hasReducedSpacing: _stencilReactDesc.PropTypes.bool.description('Indicates that this Td should have minimal spacing.')
});
Td.defaultProps = _objectSpread({}, _constants2.tdDefaultProps);
Td.displayName = 'Td';
var _default = Td;
exports.default = _default;